var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 85,
    viewBox: "0 0 183 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    id: "path-xs",
    d: "M182.315 24.5847C183.326 29.6885 181.79 35.0695 178.099 40.4433C174.407 45.818 168.571 51.1675 161.024 56.1895C145.932 66.2328 124.04 74.938 98.9261 79.9125C73.8124 84.887 50.255 85.1845 32.4734 81.6529C23.582 79.887 16.1474 77.1662 10.6857 73.6046C5.22487 70.0436 1.75333 65.6546 0.742358 60.5507C-0.268617 55.4469 1.26766 50.0659 4.95865 44.6921C8.65029 39.3174 14.4863 33.968 22.0332 28.9459C37.1259 18.9026 59.0179 10.1974 84.1315 5.22291C109.245 0.248385 132.803 -0.0490914 150.584 3.48249C159.476 5.24839 166.91 7.96919 172.372 11.5308C177.833 15.0918 181.304 19.4808 182.315 24.5847Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXs);
export default __webpack_public_path__ + "static/media/xs.61f6441c.svg";
export { ForwardRef as ReactComponent };